<template>
  <div
    class="quark-element-wrapper"
    :id="element.uuid"
    @click="handleClick"
    :ref="refId"
  >
    <component
      :is="element.elName"
      class="quark-element ani"
      v-bind="element.propsValue"
      :ref="refChild"
      :uuid="element.uuid"
    >
      <slot></slot>
    </component>
  </div>
</template>

<script>
import { _qk_register_components_object } from "@/plugins/components/index";
import runAnimations from "@/assets/js/runAnimations";
import elementEvents from "@/assets/js/elementEvents";

export default {
  name: "components-template",
  components: {
    ..._qk_register_components_object,
  },
  data() {
    const time = new Date().getTime();
    return {
      refId: time,
      refChild: time + "_child",
    };
  },
  props: {
    loaded: Boolean,
    // 元素数据
    element: {
      type: Object,
      require: true,
    },
    elementsAll: Array,
    elementGroups: Array,
    scalingRatio: Number,
  },
  mixins: [elementEvents],
  mounted() {
    setTimeout(() => {
      const _this = this;
      if (this.loaded) {
        this.cssAnimations();
      }
      if (
        this.element.elName == "qk-video" &&
        this.element.propsValue.autoPlay
      ) {
        const observer = new MutationObserver(function (
          mutationsList,
          // eslint-disable-next-line no-unused-vars
          observer
        ) {
          for (let mutation of mutationsList) {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "style"
            ) {
              if (mutation.target.style.display == "block") {
                setTimeout(() => {
                  _this.$refs[_this.refChild].play &&
                    _this.$refs[_this.refChild].play();
                  const doPlay = () => {
                    document.removeEventListener("WeixinJSBridgeReady", doPlay);
                    // eslint-disable-next-line no-undef
                    WeixinJSBridge.invoke("getNetworkType", {}, () => {
                      _this.$refs[_this.refChild].play &&
                        _this.$refs[_this.refChild].play();
                    });
                  };
                  if (window.WeixinJSBridge) {
                    doPlay();
                  } else {
                    document.addEventListener(
                      "WeixinJSBridgeReady",
                      doPlay,
                      false
                    );
                  }
                }, 300);
              }
            }
          }
        });
        observer.observe(_this.$refs[_this.refId], { attributes: true });
      }
      if (
        this.element.elName == "qk-video" &&
        this.element.propsValue.autoPlay &&
        this.element.commonStyle.display == "block"
      ) {
        setTimeout(() => {
          _this.$refs[_this.refChild].play &&
            _this.$refs[_this.refChild].play();

          const doPlay = () => {
            document.removeEventListener("WeixinJSBridgeReady", doPlay);
            // eslint-disable-next-line no-undef
            WeixinJSBridge.invoke("getNetworkType", {}, () => {
              _this.$refs[_this.refChild].play &&
                _this.$refs[_this.refChild].play();
            });
          };
          if (window.WeixinJSBridge) {
            doPlay();
          } else {
            document.addEventListener("WeixinJSBridgeReady", doPlay, false);
          }
        }, 300);
      }
    }, 0);
  },
  watch: {
    loaded(val) {
      if (val) {
        this.cssAnimations();
      }
    },
  },
  methods: {
    async handleClick() {
      for (let i = 0, len = this.element.events.length; i < len; i++) {
        if (this["_event_" + this.element.events[i].type]) {
          await this["_event_" + this.element.events[i].type](
            this.element.events[i],
            this
          );
        }
      }
    },
    cssAnimations() {
      // let cssText = this.$el.style.cssText;
      let animations = this.element.animations || [];
      animations = animations.filter(
        (z) => z.type.toLowerCase().indexOf("in") > -1
      );
      runAnimations(this.$el, animations, false, () => {
        // this.$el.style.cssText = cssText
      });
    },
  },
};
</script>
